import Home from './features/home/Home'

const App = () => {
  return <Home />
}

export default App
